import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Glide from '@glidejs/glide';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/bx-chevron-right.svg'; // import Glide from '@glidejs/glide/dist/glide.modular.esm';

export default {
  name: 'Glide',
  // functional: true,
  props: {
    itemsLength: {
      type: Number,
      default: 1
    },
    gap: {
      type: Number,
      default: 0
    },
    autoplay: {
      type: [Boolean, Number],
      default: false
    },
    hoverpause: {
      type: Boolean,
      default: false
    },
    startAt: {
      type: Number,
      default: 0
    },
    withArrows: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      glide: null
    };
  },
  computed: {
    options: function options() {
      return {
        gap: this.gap,
        autoplay: this.autoplay,
        hoverpause: this.hoverpause,
        startAt: this.startAt
      };
    }
  },
  mounted: function mounted() {
    this.initSlider();
  },
  updated: function updated() {
    if (this.glide) {
      this.glide.update(this.options);
    }
  },
  methods: {
    initSlider: function initSlider() {
      if (this.itemsLength > 1) {
        this.glide = new Glide(this.$refs.glideElement, {
          gap: this.gap,
          autoplay: this.autoplay,
          hoverpause: false
        }).mount();
      }
    }
  }
};